import { amber, green } from "@mui/material/colors";
import { useCallback } from "react";

export const useGetRowStyles = () => {
  return useCallback((params) => {
    if (params?.data?.isHidden) {
      return {
        background: amber[50],
        borderLeft: `4px solid ${amber[200]}`,
      };
    }
    if (params?.data?.isFinal) {
      return {
        borderLeft: `4px solid ${green[500]}`,
        background: "#f9fef7",
      };
    }
    return { borderLeft: "3px solid transparent" };
  }, []);
};
